import React from 'react';
import HeadingDescription from '../HeadingDescription';
import PointersWithHeading from '../PointersWithHeading';
// eslint-disable-next-line no-unused-vars -- used in JSX
import ProposalImage from '../ProposalImage';
import heatingOptions from '../../assets/proposalImages/industrial_heating_options.jpg';


function renderOvenTypes(types) {
  if (!types || !types.length) return null;
  return (
    <PointersWithHeading
      items={types.map((t) => ({ title: t.title || t.text, description: Array.isArray(t.description) ? t.description.join(' ') : t.description }))}
      numbered
    />
  );
}

export default function HeatingOptionsSection({ heatingSection }) {
  if (!heatingSection) return null;

  return (
    <div className="a4-paddings quotation-page quotation-machines-details-page">
      <div className="quotation-page-inner quotation-bg-light">
        <div className="quotation-section-block">
          <HeadingDescription heading="Industrial Heating Options" description={heatingSection.description} level={3} />
          {heatingSection.types && renderOvenTypes(heatingSection.types)}
        </div>
         <HeadingDescription heading="LPG/Diesel Fired Heat Exchanger" description={""} level={3} hideLine={true} />
        <ProposalImage src={heatingOptions} wrapperStyle={{ marginBottom: 12 }} />
      </div>
    </div>
  );
}
